import React from 'react'
import { NAVIGACIJOS } from '../utils/navigacija'

// Navigacijos programos pasirinkimas (bottom sheet). Pirmą kartą — pasirenki pagrindinę;
// vėliau atidaromas palaikius „Kelias iki čia", kad pakeistum.
const IKONOS = {
  map: <><path d="M9 4L3 6v14l6-2 6 2 6-2V4l-6 2-6-2z" /><line x1="9" y1="4" x2="9" y2="18" /><line x1="15" y1="6" x2="15" y2="20" /></>,
  waze: <><circle cx="12" cy="11" r="8" /><path d="M8.5 16.5c1 1.2 2.2 1.8 3.5 1.8s2.5-.6 3.5-1.8" /><circle cx="9.5" cy="10" r=".6" fill="currentColor" /><circle cx="14.5" cy="10" r=".6" fill="currentColor" /><path d="M6 20l1-2M18 20l-1-2" /></>,
  apple: <><path d="M15.5 3c.2 1.2-.3 2.3-1 3.1-.7.8-1.8 1.4-2.9 1.3-.2-1.1.4-2.3 1.1-3C13.4 3.5 14.6 3 15.5 3z" /><path d="M18.5 16.5c-.5 1.2-.8 1.7-1.5 2.8-1 1.5-2.3 3.3-4 3.3-1.5 0-1.9-.9-3.9-.9s-2.5.9-3.9.9c-1.7 0-3-1.7-4-3.2-2.7-4.2-3-9.1-1.3-11.7C5.1 8.3 6.8 7.3 8.4 7.3c1.6 0 2.7 1 4 1 1.3 0 2-1 3.9-1 1.4 0 2.9.8 4 2.1-3.5 1.9-2.9 6.9.2 8.1z" /></>,
}

function Ikona({ ikona }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      {IKONOS[ikona] || IKONOS.map}
    </svg>
  )
}

function NavigacijaPasirinkimas({ atidaryta, dabartine, onPasirinkti, onClose }) {
  const variantai = NAVIGACIJOS

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1200, opacity: atidaryta ? 1 : 0, pointerEvents: atidaryta ? 'auto' : 'none', transition: 'opacity 0.3s ease' }} />
      <div style={{ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 1201, background: '#1E2E27', borderRadius: '20px 20px 0 0', borderTop: '1px solid #2A3B32', transform: atidaryta ? 'translateY(0)' : 'translateY(100%)', transition: 'transform 0.35s cubic-bezier(0.32,0.72,0,1)' }}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 4px' }}>
          <div style={{ width: 36, height: 4, borderRadius: 2, background: 'rgba(240,232,213,0.2)' }} />
        </div>
        <div style={{ padding: '6px 20px calc(20px + env(safe-area-inset-bottom))' }}>
          <h2 style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: 20, fontWeight: 500, margin: '4px 0 4px' }}>Kuo naviguoti?</h2>
          <p style={{ color: '#7A8A7E', fontSize: 12.5, margin: '0 0 14px', lineHeight: 1.5 }}>Pasirink pagrindinę — vėliau pakeisi palaikęs „Kelias iki čia".</p>

          {variantai.map(n => {
            const aktyvus = dabartine === n.id
            return (
              <button
                key={n.id}
                onClick={() => onPasirinkti(n.id)}
                style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left', padding: '13px 14px', borderRadius: 11, cursor: 'pointer', border: `1px solid ${aktyvus ? 'rgba(229,168,64,0.45)' : '#2A3B32'}`, background: aktyvus ? 'rgba(229,168,64,0.12)' : 'transparent', marginBottom: 8, fontFamily: 'Syne, system-ui, sans-serif', color: aktyvus ? '#E5A840' : '#F0E8D5' }}
              >
                <Ikona ikona={n.ikona} />
                <span style={{ flex: 1, fontSize: 15 }}>{n.pavadinimas}</span>
                {aktyvus && <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E5A840" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>}
              </button>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default NavigacijaPasirinkimas
